import { ElementRef, Injectable } from '@angular/core';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngrx/store';
import { filter, map, take } from 'rxjs/operators';
import { BehaviorSubject, firstValueFrom } from 'rxjs';
import { AssignmentCustomerResponse, AssignmentPspResponse } from '../../../api';
import { BaseSignContractOptions } from '../../modules/assignments/_enums/base-sign-contract-options.enum';
import { baseAssignmentsActions, baseAssignmentsSelectors, BaseCoreState } from '../../_store';
import { BaseModalService } from './base-modal.service';

@Injectable({ providedIn: 'root' })
export class BaseSignatureService {
  modalRef: NgbModalRef;
  baseSignContractsInfoCardIsInitSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor(private modalService: BaseModalService, private store: Store<BaseCoreState>) {}

  getAssignmentForSignUp(id: number): Promise<AssignmentPspResponse | AssignmentCustomerResponse> {
    this.store.dispatch(baseAssignmentsActions.loadAssignment({ payload: { assignment: id } }));

    return firstValueFrom(
      this.store.select(baseAssignmentsSelectors.getAssignment).pipe(
        filter((assignmentState) => assignmentState.ok === true),
        map((assignmentState) => assignmentState.data),
        take(1)
      )
    );
  }

  openSignContractModal(addSignSelectionPopup: ElementRef): NgbModalRef {
    return this.modalService.open(
      {
        headText: 'operations.signContract',
        bodyTemplate: addSignSelectionPopup,
        cancelButtonDisplayed: false,
        okButtonDisplayed: false,
        hideFooter: true,
      },
      {
        size: 'lg',
      }
    );
  }

  dispatchAssignContractAction(
    assignmentId: number,
    contractId: number,
    signingType: BaseSignContractOptions | undefined,
    reloadAssignmentInfo: boolean
  ): void {
    this.store.dispatch(
      baseAssignmentsActions.signContract({
        payload: {
          assignment: assignmentId,
          contract: contractId,
          signingType: signingType as BaseSignContractOptions,
          reloadAssignmentInfo,
        },
      })
    );
  }

  openDigitalSignModal(signModal: ElementRef): NgbModalRef {
    return this.modalService.open(
      {
        bodyTemplate: signModal,
        cancelButtonDisplayed: false,
        okButtonDisplayed: false,
        hideCloseIcon: true,
        hideHeader: true,
        hideFooter: true,
      },
      {
        scrollable: false,
        backdrop: 'static',
        size: 'lg',
      }
    );
  }
}
